<template>
  <div :class="[isSelected ? 'espacio-privado-activo' : 'espacio-privado']">
    <div @click="click" style="display: flex; width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
      <img class="open-safebox" src="/img/icons/privateSpacesIcon/openSafebox-icon.svg">
      <span :title="name">{{ name }}</span>
    </div>
    <img class="close" src="/img/icons/privateSpacesIcon/closeIcon.svg" @click="closePrivateSpace">
  </div>
</template>

<script>
import { files as ibbapi } from '@/api';
import { mapMutations, mapState } from 'vuex';
import { ROUTES } from '../router';

export default {
  name: 'private-space',
  data: function() {
    return {
      isClick: false
    };
  },
  computed: {
    ...mapState([
      'handleOpenSpace'
    ]),
    isSelected() {
      if ((this.handleOpenSpace === this.handle) && (this.$route.name === ROUTES.SECRET)) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: ['name', 'handle'],
  methods: {
    ...mapMutations([ 'setHandleOpenSpace' ]),
    click() {
      this.setHandleOpenSpace(this.handle);
      if (this.$route.fullPath !== ('/sec#' + this.handle)) {
        this.$router.push({path: '/sec' + '#' + this.handle});
      }
    },
    async closePrivateSpace() {
      try {
        if (this.handleOpenSpace === this.handle) {
          this.$router.push({path: '/cloud'});
        }
        await ibbapi.closeSecret(this.handle);
      } catch (e) {
        this.$showError(e);
      }
    }
  }
};
</script>